import React from 'react';
import { Link } from 'react-router-dom';
import './SheetsPage.css';

export default function SheetsPage() {
  return (
    <main className="sh">
      <div className="sh__bg" />

      {/* ── Hero ── */}
      <section className="sh__hero">
        <div className="sh__eyebrow">
          <span className="sh__eyebrow-dot" />
          Active Challenges
        </div>

        <h1 className="sh__h1">
          <span className="sh__h1-dim">Master Data Structures with</span><br />
          <span className="sh__h1-acc">Code Crusaders Sheets</span>
        </h1>

        <p className="sh__sub">
          Comprehensive visual walkthroughs, precise algorithmic templates, and complexity breakdowns tracked element-by-element.
        </p>

        {/* ── Challenge Nav Card ── */}
        <div className="sh__striver-card">
          <div className="sh__striver-card-hd">
            <span className="sh__badge-live">LIVE CHALLENGE</span>
            <span className="sh__badge-date">Updated Dec 2025</span>
          </div>
          <h2 className="sh__striver-title">Striver SDE Master Sheet</h2>
          <p className="sh__striver-desc">
            Track all 191 top coding interview problems curated by takeUforward. Dive deep into clean solutions, complexity analyses, and interactive visual runtime walkthrough steps.
          </p>
          <Link to="/sheets/striver-challenge" className="sh__striver-btn">
            Launch Sheet Dashboard →
          </Link>
        </div>
      </section>
    </main>
  );
}
